export enum PatientGender {
  'Female' = 0,
  'Male' = 1,
  'Other' = 2,
}
